import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";
import { Observable } from "rxjs/Observable";

let $_: any;
declare const firebase: any;

const config = {

    apiKey: "AIzaSyC5643VyGuU6dx8xVeDKE9u2ONRAVYJWKE",
    authDomain: "sinirji911-live.firebaseapp.com",
    databaseURL: "https://sinirji911-live.firebaseio.com",
    projectId: "sinirji911-live",
    storageBucket: "sinirji911-live.appspot.com",
    messagingSenderId: "869628697678"
};

@Injectable()
export class FirebaseService {

    public db: any;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {

        $_ = this;

        if (isPlatformBrowser($_.platformId)) {

            firebase.initializeApp(config);

            // removed - not required
            //firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE)
            //    .then(() => {console.info("User Persistence Enabled")})
            //    .catch(error => console.error(error));

            $_.db = firebase.firestore();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/services/firebase/firebase.service.ts